import React from 'react';
import './App.css';
import ArticleTile from './components/ArticleTiles';
import {
  FlexLayout,
  Paragraph,
  Title
} from '@nutanix-ui/prism-reactjs';

export default function Tales(props) {



return (
  <FlexLayout flexDirection="column" itemSpacing="80px">
    <FlexLayout justifyContent="space-between">
      <Title size="h2" className="darkSectionTitle" style={{ width: '30%'}}>Tales from the field</Title>
      <Paragraph className="darkSectionDescription" style={{ width: '55%', marginLeft: '50px', marginTop: '10px', marginRight: '100px'}}>We share our thoughts on design with the community. Explore selected perspectives on the craft of design, case studies, and experiences from fellow designers at Nutanix.
</Paragraph>

    </FlexLayout>
    <article>
    <FlexLayout justifyContent="center">

     {props.articles.map((article) => (
         <ArticleTile key={article.link} image={article.img} title={article.title} description={article.content} link={article.link}/>
     ))}

    </FlexLayout>
    </article>





  </FlexLayout>
);


}
